import { CompositeMeterData } from '@models/meter-scans/composite/composite-meter-data';
import { LocationData } from './location-data';

export class PingData extends CompositeMeterData {
    userId: string;
    mac: string;
    workorder: number;
    location: string;
    locationComment: string;
    account: number;
    timestamp: number;
    uploadTimestamp: number;
    latitude: number;
    longitude: number;
    locationData: LocationData;
    pingData: Ping;
    pingClient: string;

    constructor(
        httpResponse: PingData
    ) {
        super();
        this.account = httpResponse.account; // Here for model uniformity. necessary for referenceSweep.;
        this.timestamp = httpResponse.timestamp;
        this.latitude = httpResponse.latitude;
        this.longitude = httpResponse.longitude;
        this.locationComment = httpResponse.locationComment;
        this.location = httpResponse.location;
        this.mac = httpResponse.mac;
        this.pingData = httpResponse.pingData;
        this.uploadTimestamp = httpResponse.uploadTimestamp;
        this.userId = httpResponse.userId;
        this.workorder = httpResponse.workorder;
        this.pingClient = httpResponse.pingClient;
    }
}

export interface Ping {
    latency: LatencyOrJitter;
    latencyHistory: LatencyHistoryEntityOrJitterHistoryEntity[];
    jitter: LatencyOrJitter;
    jitterHistory: LatencyHistoryEntityOrJitterHistoryEntity[];
    packetLossHistory: (number)[];
    hostname: string;
}
export interface LatencyOrJitter {
    current: number;
    average: number;
    minimum: number;
    maximum: number;
    standardDeviation: number;
}
export interface LatencyHistoryEntityOrJitterHistoryEntity {
    x: number;
    y: number;
}
